import { BehaviorSubject } from 'rxjs';

export class LoadingBehaviorSubject extends BehaviorSubject<boolean> {
    constructor(value: boolean = false) {
        super(value);
    }

    startLoading() {
        this.next(true);
    }

    stopLoading() {
        this.next(false);
    }
}
